"use strict";

exports.__esModule = true;
exports.StyledFormGroup = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getStyles = props => {
  switch (props.hasOwnProperty('inline')) {
    case true:
      return `
                display: flex;
                align-items: center;
            `;

    default:
      return `
                display: block;
            `;
  }
};

const StyledFormGroup = _styledComponents.default.div`
    ${props => getStyles(props)}
    width: 100%;
    margin-bottom: ${props => props.theme.space[5]};
    text-align: left;

    label {
        font-weight: ${props => props.theme.formLabelFontWeight};
    }

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.position}
`;
exports.StyledFormGroup = StyledFormGroup;